const _state = {
  isEnableAudienceAdmissionForm: false,
}

const getters = {
  isEnableAudienceAdmissionForm(_, __, rootState) {
    const {
      audienceAdmission,
      disableFormJoinPresentation,
    } = rootState.presentation
    let enableAudienceAdmissionForm = false
    if (
      !disableFormJoinPresentation &&
      audienceAdmission &&
      audienceAdmission.isAudienceAdmission &&
      audienceAdmission.fields &&
      audienceAdmission.fields.length
    ) {
      audienceAdmission.fields.forEach((item) => {
        if (item.type === 'name' && !rootState.audienceName) {
          enableAudienceAdmissionForm = true
        }
        if (item.type === 'email' && !rootState.audienceEmail) {
          enableAudienceAdmissionForm = true
        }
        if (item.type === 'team' && !rootState.audienceTeam) {
          enableAudienceAdmissionForm = true
        }
      })
    }
    return enableAudienceAdmissionForm
  },
}

const actions = {

}

const mutations = {}

export default {
  namespaced: true,
  state: _state,
  getters,
  actions,
  mutations,
}
